/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { HDMTheme } from '@/styles/HDM/theme';
import { ThemeManifest } from '@/styles/manifest';

export const themeManifestCustom: ThemeManifest = {
	defaultTheme: 'HDMTheme',
	themes: { HDMTheme },
};
